export enum BrokeredProvider {
    Microsoft = "microsoft",
    Google = "google",
}

export interface AuthUser {
    id: string;
    name: string;
    email: string;
    username: string;
    externalUserId: string;
}

interface AuthState {
    isAuthenticated: boolean;
}

export interface AuthContextValue extends AuthState {
    login: () => Promise<void>;
    logout: () => Promise<void>;

    loginRedirect: () => Promise<void>;
    logoutRedirect: () => Promise<void>;

    getAccessToken: () => Promise<string>;
    getProviderToken: () => Promise<string>;
    getBrokeredProvider: () => BrokeredProvider;

    forceRefresh: () => Promise<void>;

    getUser: () => AuthUser;
}
